import { background, text } from '../colors/palettes';

// The page size for the *infinite-scroll* lists — users, deactivated users, and the
// organization roster. Paged admin tables use SUPER_ADMIN_PAGE_SIZE instead.
//
// It must stay equal to DEFAULT_ITEMS_PER_PAGE: useInfinitePaginationWithSearch sends this
// value and compares the returned count against that one to decide whether more pages
// exist. Raise one without the other and the list either stops early or fetches a page it
// does not need.
export const ITEMS_PER_PAGE = 10;

const tableTheme = {
  Table: `
    padding: 40px;
    border-radius: 10px;
    background-color: white;
    box-shadow: 0px 10px 40px 0px #00417926;
  `,
  Header: '',
  Body: '',
  BaseRow: `
    font-size: 16px;
    padding: 5px;
  `,
  HeaderRow: `
    font-size: 12px;
    font-weight: bold;
    color: ${text.mediumGray};
  `,
  Row: `
    color: ${text.mediumBlue};
    font-weight: 600;
    max-height: 35px;

    &.disabled {
      color: ${background.lightGray};
    }

    &:hover {
      color: ${text.mediumBlue};
    }

    &:not(:last-of-type) > .td {
      border-bottom: 1px solid ${background.separatorBlue};
    }
  `,
  BaseCell: ``,
  HeaderCell: `
    font-weight: bold;
    border-bottom: 0;
    
  `,
  Cell: `
    padding: 10px;
    padding-left: 0px;
    min-height: 55px;

    &:focus {
      outline: dotted;
      outline-width: 1px;
      outline-offset: -1px;
    }
  `,
};

export default tableTheme;
